import styled from 'styled-components';

const H2 = styled.h2`
  font-size: 18px;
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: normal;
`;

export default H2;



// WEBPACK FOOTER //
// ./components/atoms/H2.js